import type { SensorData } from 'Simulations/SensorPoint';
import * as THREE from 'three';
import FVector from '@data/geometry/FVector';
import { Facade } from '../Facade';

export type ComponentBaseParams = {
    p1: FVector;
    p2: FVector;
    height: number;
    material: THREE.Material;
    sensors?: SensorData[];
    direction?: FVector;
};

export type FacadeComponentContext = ComponentBaseParams & {
    thickness: number;
    perimeter: FVector[];
    visibilityLoops: FVector[][];
    renderWhenBlocked: boolean;
    requireActiveSensors: boolean;
    edgeIndex: number;
    renderedIndices: Set<number>;
};

/**
 * Base class for facade-attached components.
 * Mirrors the Facade constructor shape so existing facade implementations
 * can be migrated incrementally to component-based variants.
 */
export class Component extends Facade {
    constructor(params: ComponentBaseParams) {
        super(params.p1, params.p2, params.height, params.material, params.sensors ?? [], params.direction);
    }
}
